module.exports = {
  title: '用户详情',
  route: {
    path: 'user-manage',
    children: {
      path: 'user-detail',
    },
  },
};
